import state from '@/vuex/administracao/edicao-tipo-documental/state.js'
import getters from '@/vuex/administracao/edicao-tipo-documental/getters.js'
import mutations from '@/vuex/administracao/edicao-tipo-documental/mutations.js'
import actions from '@/vuex/administracao/edicao-tipo-documental/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
